const languages = {
    "en": {
      userContentWarning: "Please do not share any controlled / confidential information or inappropriate language in your response.",
      generatedOn: "Generated on",
      questions: "Questions",
      takes: "Takes",
      seconds: "seconds",
      letsDoIt: "Let's do it",
      thanksForYourTime: "Thanks for your time!",
      messageSubmittedSuccess: "Successfully submitted. Feel free to add another one.",
      sending: "Sending...",
      question: "Question",
      next: "Next",
      of: "Of",
      submit: "Submit",
      skip: "Skip",
      ratingInputPlaceHolder: "Type your comment (Optional)",
      reinforceButton: "Reinforce your learning",
      yourAnswer: "Your Answer",
      correctAnswer: "Correct Answer",
      answerResultEndingPage: "you answered {{@}} out of {{@@}} questions correctly.",
      youCan: "You can",
      shareTrivvy: "Share Trivvy",
      orReturnTo: "or return to",
      myTrivvys: "My Trivvys",
      rewardText: "Take this trivvy to win exciting rewards:",
      clickToSeeText: "Click here to see text",
      notTimed: "Not timed",
      viewSummary: "View summary",
      submitAnonymously: "Submit Anonymously",
      percentToPass: "Percent to Pass",
      trivvyEnded: "Sorry. This trivvy has ended as of ",
    
      mcqsAreTimed: "Multiple Choice Questions are timed",
      employeeIdRequired: "Employee Id required",
      employeeIdNotRequired: "Employee Id not required",
      employeeId: "Employee Id",
      required: "Required",
      enterEmployeeId: "Please enter employee id",
      emailIsRequired: "Email is required",
      emailIsNotRequired: "Email is not required",
      email: "Email",
      enterEmail: "Please enter email",
      mobile: "Mobile Number",
      enterFirstName: "Please enter First Name",
      enterLastName: "Please enter Last Name",
      enterMobile: "Mobile Number is required",
      mobileNumberIsNotRequired: "Mobile Number is not required",
      mobileNumberIsRequired: "Mobile Number is required",
      firstName: "First Name",
      lastName: "Last Name",
      firstNameAndLastNameRequired: "First Name and Last Name are required",
      firstNameAndLastNameNotRequired: "First Name and Last Name are not required",
      firstNameIsRequired: "First Name is required",
      firstNameIsNotRequired: "First Name is not required",
      lastNameIsRequired: "Last Name is required",
      lastNameIsNotRequired: "Last Name is not required",
      anonymous:"anonymous",
      name: "Name",
      nameIsRequired: "Please enter name",
      endDate: "End Date",
      customData: "Custom Data",
      correct: "Correct",
      timedOut: "Timed out",
      submitRatingLoading: "Submitting rating please wait",
      submitRatingRequiredMessage: "You need to submit rating to see results",
      sourceLink: "Source link",
      sourceText: "Source text",
      customText: "Custom text",
      endingPassingPerMessage1: "Congrats you passed! The Passing Percentage is",
      endingPassingPerMessage2: "and you achieved a",
      niceJob: "Nice Job",
      endingNoPassMessage1: "The Passing percentage is",
      endingNoPassMessage2: "You received a",
      endingNoPassMessage3: "You can retake to try to improve your score",
      clickHere: "Click here",
      toRetake: " to retake",
      trivvyNotSharedApiMessage: "You are not allowed to take this trivvy isn't shared with you please contact your Admin.",
      passedTrivvyAlreadyApiMessage: "You have passed the trivvy already",
      attemptLimitExceededApiMessage: "Sorry, You have exceeded the attempt limit of trivvy",
      trivvyNotPublishedApiMessage: "The trivvy is not published, Please contact your admin.",
      trivvyAlreadyAttemptedApiMessage: "You already attempted this Trivvy and you are not allowed to take it again. Please contact your Admin.",
      cantTakeTrivvyAgainApiMessage: "You can’t take the same Trivvy more than once",
      scaleMinLabel: "Lowest",
      scaleMaxLabel: "Highest",
    },
    "es-MX": {
      userContentWarning: "Por favor, no comparta información controlada / confidencial ni lenguaje inapropiado en su respuesta.",
      generatedOn: "Generado el",
      questions: "Preguntas",
      takes: "Toma",
      seconds: "segundos",
      letsDoIt: "Vamos a hacerlo",
      thanksForYourTime: "¡Gracias por tu tiempo!",
      messageSubmittedSuccess: "Enviado exitosamente. Siéntete libre de agregar otro.",
      sending: "Enviando...",
      question: "Pregunta",
      next: "Siguiente",
      of: "De",
      submit: "Enviar",
      skip: "Omitir",
      ratingInputPlaceHolder: "Escribe tu comentario (Opcional)",
      reinforceButton: "Refuerza tu aprendizaje",
      yourAnswer: "Tu Respuesta",
      correctAnswer: "Respuesta Correcta",
      answerResultEndingPage: "respondiste correctamente {{@}} de {{@@}} preguntas.",
      youCan: "Puedes",
      shareTrivvy: "Compartir Trivvy",
      orReturnTo: "o volver a",
      myTrivvys: "Mis Trivvys",
      rewardText: "Tome este trivvy para ganar emocionantes recompensas:",
    clickToSeeText: "Haga clic aquí para ver el texto",
    notTimed: "No cronometrado",
    viewSummary: "Ver resumen",
    submitAnonymously: "Enviar anónimamente",
    percentToPass: "Porcentaje para aprobar",
    trivvyEnded: "Lo siento. Este trivvy ha terminado el",
    mcqsAreTimed: "Las preguntas de opción múltiple están cronometradas",
    employeeIdRequired: "Se requiere identificación de empleado",
    employeeId: "Identificación del empleado",
    required: "Requerido",
    enterEmployeeId: "Por favor, ingrese la identificación del empleado",
    emailIsRequired: "Se requiere correo electrónico",
    email: "Correo electrónico",
    enterEmail: "Por favor, ingrese el correo electrónico",
    name: "Nombre",
    nameIsRequired: "Por favor, ingrese el nombre",
    endDate: "Fecha de finalización",
    customData: "Datos personalizados",
    correct: "Correcto",
    timedOut: "Tiempo agotado",
    submitRatingLoading: "Enviando calificación, por favor espere",
    submitRatingRequiredMessage: "Necesita enviar una calificación para ver los resultados",
    sourceLink: "Enlace fuente",
    sourceText: "Texto fuente",
    customText: "Texto personalizado",
    endingPassingPerMessage1: "¡Felicidades, aprobaste! El porcentaje de aprobación es",
    endingPassingPerMessage2: "y lograste un",
    niceJob: "Buen trabajo",
    endingNoPassMessage1: "El porcentaje de aprobación es",
    endingNoPassMessage2: "Recibiste un",
    endingNoPassMessage3: "Puedes retomar para intentar mejorar tu puntuación",
    clickHere: "Haz clic aquí",
    toRetake: " para retomar",
    trivvyNotSharedApiMessage: "No tienes permiso para tomar este trivvy, no está compartido contigo. Por favor, contacta a tu administrador.",
    passedTrivvyAlreadyApiMessage: "Ya has pasado el trivvy",
    attemptLimitExceededApiMessage: "Lo siento, has excedido el límite de intentos del trivvy",
    trivvyNotPublishedApiMessage: "El trivvy no está publicado, por favor contacta a tu administrador.",
    trivvyAlreadyAttemptedApiMessage: "Ya intentaste este Trivvy y no tienes permiso para tomarlo de nuevo. Por favor, contacta a tu administrador.",
    cantTakeTrivvyAgainApiMessage: "No puedes tomar el mismo Trivvy más de una vez",
   
      scaleMinLabel: "Más bajo",
      scaleMaxLabel: "Más alto",
    },
    "es": {
      userContentWarning: "Por favor, no compartas información controlada / confidencial ni lenguaje inapropiado en tu respuesta.",
      generatedOn: "Generado el",
      questions: "Preguntas",
      takes: "Toma",
      seconds: "segundos",
      letsDoIt: "Vamos a hacerlo",
      thanksForYourTime: "¡Gracias por tu tiempo!",
      messageSubmittedSuccess: "Enviado correctamente. Siéntete libre de añadir otro.",
      sending: "Enviando...",
      question: "Pregunta",
      next: "Siguiente",
      of: "De",
      submit: "Enviar",
      skip: "Saltar",
      ratingInputPlaceHolder: "Escribe tu comentario (Opcional)",
      reinforceButton: "Refuerza tu aprendizaje",
      yourAnswer: "Tu Respuesta",
      correctAnswer: "Respuesta Correcta",
      answerResultEndingPage: "respondiste correctamente {{@}} de {{@@}} preguntas.",
      youCan: "Puedes",
      shareTrivvy: "Compartir Trivvy",
      orReturnTo: "o volver a",
      myTrivvys: "Mis Trivvys",
      rewardText: "Tome este trivvy para ganar emocionantes recompensas:",
    clickToSeeText: "Haga clic aquí para ver el texto",
    notTimed: "No cronometrado",
    viewSummary: "Ver resumen",
    submitAnonymously: "Enviar anónimamente",
    percentToPass: "Porcentaje para aprobar",
    trivvyEnded: "Lo siento. Este trivvy ha terminado el",
    mcqsAreTimed: "Las preguntas de opción múltiple están cronometradas",
    employeeIdRequired: "Se requiere identificación de empleado",
    employeeId: "Identificación del empleado",
    required: "Requerido",
    enterEmployeeId: "Por favor, ingrese la identificación del empleado",
    emailIsRequired: "Se requiere correo electrónico",
    email: "Correo electrónico",
    enterEmail: "Por favor, ingrese el correo electrónico",
    name: "Nombre",
    nameIsRequired: "Por favor, ingrese el nombre",
    endDate: "Fecha de finalización",
    customData: "Datos personalizados",
    correct: "Correcto",
    timedOut: "Tiempo agotado",
    submitRatingLoading: "Enviando calificación, por favor espere",
    submitRatingRequiredMessage: "Necesita enviar una calificación para ver los resultados",
    sourceLink: "Enlace fuente",
    sourceText: "Texto fuente",
    customText: "Texto personalizado",
    endingPassingPerMessage1: "¡Felicidades, aprobaste! El porcentaje de aprobación es",
    endingPassingPerMessage2: "y lograste un",
    niceJob: "Buen trabajo",
    endingNoPassMessage1: "El porcentaje de aprobación es",
    endingNoPassMessage2: "Recibiste un",
    endingNoPassMessage3: "Puedes retomar para intentar mejorar tu puntuación",
    clickHere: "Haz clic aquí",
    toRetake: " para retomar",
    trivvyNotSharedApiMessage: "No tienes permiso para tomar este trivvy, no está compartido contigo. Por favor, contacta a tu administrador.",
    passedTrivvyAlreadyApiMessage: "Ya has pasado el trivvy",
    attemptLimitExceededApiMessage: "Lo siento, has excedido el límite de intentos del trivvy",
    trivvyNotPublishedApiMessage: "El trivvy no está publicado, por favor contacta a tu administrador.",
    trivvyAlreadyAttemptedApiMessage: "Ya intentaste este Trivvy y no tienes permiso para tomarlo de nuevo. Por favor, contacta a tu administrador.",
    cantTakeTrivvyAgainApiMessage: "No puedes tomar el mismo Trivvy más de una vez",
      scaleMinLabel: "Más bajo",
      scaleMaxLabel: "Más alto",
    },
    "fr": {
      userContentWarning: "Veuillez ne partager aucune information contrôlée / confidentielle ni langage inapproprié dans votre réponse.",
      generatedOn: "Généré le",
      questions: "Questions",
      takes: "Prend",
      seconds: "secondes",
      letsDoIt: "Faisons-le",
      thanksForYourTime: "Merci de votre temps !",
      messageSubmittedSuccess: "Soumis avec succès. N'hésitez pas à en ajouter un autre.",
      sending: "Envoi en cours...",
      question: "Question",
      next: "Suivant",
      of: "De",
      submit: "Soumettre",
      skip: "Passer",
      ratingInputPlaceHolder: "Tapez votre commentaire (Facultatif)",
      reinforceButton: "Renforcez votre apprentissage",
      yourAnswer: "Votre Réponse",
      correctAnswer: "Réponse Correcte",
      answerResultEndingPage: "vous avez répondu correctement à {{@}} sur {{@@}} questions.",
      youCan: "Vous pouvez",
      shareTrivvy: "Partager Trivvy",
      orReturnTo: "ou revenir à",
      myTrivvys: "Mes Trivvys",
      rewardText: "Prenez ce trivvy pour gagner des récompenses excitantes:",
      clickToSeeText: "Cliquez ici pour voir le texte",
      notTimed: "Non chronométré",
      viewSummary: "Voir le résumé",
      submitAnonymously: "Soumettre anonymement",
      percentToPass: "Pourcentage pour réussir",
      trivvyEnded: "Désolé. Ce trivvy s'est terminé le",
      mcqsAreTimed: "Les questions à choix multiples sont chronométrées",
    employeeIdRequired: "Identifiant employé requis",
    employeeId: "Identifiant employé",
    required: "Requis",
    enterEmployeeId: "Veuillez entrer l'identifiant employé",
    emailIsRequired: "L'email est requis",
    email: "Email",
    enterEmail: "Veuillez entrer l'email",
    name: "Nom",
    nameIsRequired: "Veuillez entrer le nom",
    endDate: "Date de fin",
    customData: "Données personnalisées",
    correct: "Correct",
    timedOut: "Temps écoulé",
    submitRatingLoading: "Envoi de la note, veuillez patienter",
    submitRatingRequiredMessage: "Vous devez envoyer une note pour voir les résultats",
    sourceLink: "Lien source",
    sourceText: "Texte source",
    customText: "Texte personnalisé",
    endingPassingPerMessage1: "Félicitations, vous avez réussi ! Le pourcentage de réussite est",
    endingPassingPerMessage2: "et vous avez obtenu un",
    niceJob: "Bon travail",
    endingNoPassMessage1: "Le pourcentage de réussite est",
    endingNoPassMessage2: "Vous avez reçu un",
    endingNoPassMessage3: "Vous pouvez recommencer pour essayer d'améliorer votre score",
    clickHere: "Cliquez ici",
    toRetake: " pour recommencer",
    trivvyNotSharedApiMessage: "Vous n'êtes pas autorisé à prendre ce trivvy, il n'est pas partagé avec vous, veuillez contacter votre administrateur.",
    passedTrivvyAlreadyApiMessage: "Vous avez déjà réussi le trivvy",
    attemptLimitExceededApiMessage: "Désolé, vous avez dépassé la limite de tentatives du trivvy",
    trivvyNotPublishedApiMessage: "Le trivvy n'est pas publié, veuillez contacter votre administrateur.",
    trivvyAlreadyAttemptedApiMessage: "Vous avez déjà tenté ce Trivvy et vous n'êtes pas autorisé à le reprendre. Veuillez contacter votre administrateur.",
    cantTakeTrivvyAgainApiMessage: "Vous ne pouvez pas prendre le même Trivvy plus d'une fois",
      scaleMinLabel: "Le plus bas",
      scaleMaxLabel: "Le plus haut",
    },
    "fr-CA": {
      userContentWarning: "Veuillez ne partager aucune information contrôlée / confidentielle ni langage inapproprié dans votre réponse.",
      generatedOn: "Généré le",
      questions: "Questions",
      takes: "Prend",
      seconds: "secondes",
      letsDoIt: "Allons-y",
      thanksForYourTime: "Merci de votre temps!",
      messageSubmittedSuccess: "Soumis avec succès. N'hésitez pas à en ajouter un autre.",
      sending: "Envoi en cours...",
      question: "Question",
      next: "Suivant",
      of: "De",
      submit: "Soumettre",
      skip: "Passer",
      ratingInputPlaceHolder: "Tapez votre commentaire (Facultatif)",
      reinforceButton: "Renforcez votre apprentissage",
      yourAnswer: "Votre Réponse",
      correctAnswer: "Réponse Correcte",
      answerResultEndingPage: "vous avez répondu correctement à {{@}} sur {{@@}} questions.",
      youCan: "Vous pouvez",
      shareTrivvy: "Partager Trivvy",
      orReturnTo: "ou revenir à",
      myTrivvys: "Mes Trivvys",
      rewardText: "Prenez ce trivvy pour gagner des récompenses excitantes:",
      clickToSeeText: "Cliquez ici pour voir le texte",
      notTimed: "Non chronométré",
      viewSummary: "Voir le résumé",
      submitAnonymously: "Soumettre anonymement",
      percentToPass: "Pourcentage pour réussir",
      trivvyEnded: "Désolé. Ce trivvy s'est terminé le",
      mcqsAreTimed: "Les questions à choix multiples sont chronométrées",
      employeeIdRequired: "Identifiant employé requis",
      employeeId: "Identifiant employé",
      required: "Requis",
      enterEmployeeId: "Veuillez entrer l'identifiant employé",
      emailIsRequired: "L'email est requis",
      email: "Email",
      enterEmail: "Veuillez entrer l'email",
      name: "Nom",
      nameIsRequired: "Veuillez entrer le nom",
      endDate: "Date de fin",
      customData: "Données personnalisées",
      correct: "Correct",
      timedOut: "Temps écoulé",
      submitRatingLoading: "Envoi de la note, veuillez patienter",
      submitRatingRequiredMessage: "Vous devez envoyer une note pour voir les résultats",
      sourceLink: "Lien source",
      sourceText: "Texte source",
      customText: "Texte personnalisé",
      endingPassingPerMessage1: "Félicitations, vous avez réussi ! Le pourcentage de réussite est",
      endingPassingPerMessage2: "et vous avez obtenu un",
      niceJob: "Bon travail",
      endingNoPassMessage1: "Le pourcentage de réussite est",
      endingNoPassMessage2: "Vous avez reçu un",
      endingNoPassMessage3: "Vous pouvez recommencer pour essayer d'améliorer votre score",
      clickHere: "Cliquez ici",
      toRetake: " pour recommencer",
      trivvyNotSharedApiMessage: "Vous n'êtes pas autorisé à prendre ce trivvy, il n'est pas partagé avec vous, veuillez contacter votre administrateur.",
      passedTrivvyAlreadyApiMessage: "Vous avez déjà réussi le trivvy",
      attemptLimitExceededApiMessage: "Désolé, vous avez dépassé la limite de tentatives du trivvy",
      trivvyNotPublishedApiMessage: "Le trivvy n'est pas publié, veuillez contacter votre administrateur.",
      trivvyAlreadyAttemptedApiMessage: "Vous avez déjà tenté ce Trivvy et vous n'êtes pas autorisé à le reprendre. Veuillez contacter votre administrateur.",
      cantTakeTrivvyAgainApiMessage: "Vous ne pouvez pas prendre le même Trivvy plus d'une fois",
      scaleMinLabel: "Le plus bas",
      scaleMaxLabel: "Le plus élevé",
    },
    "de": {
      userContentWarning: "Bitte teilen Sie in Ihrer Antwort keine vertraulichen / kontrollierten Informationen oder unangemessene Sprache mit.",
      generatedOn: "Erzeugt am",
      questions: "Fragen",
      takes: "Dauert",
      seconds: "Sekunden",
      letsDoIt: "Lass es uns tun",
      thanksForYourTime: "Danke für deine Zeit!",
      messageSubmittedSuccess: "Erfolgreich eingereicht. Du kannst gerne eine weitere hinzufügen.",
      sending: "Wird gesendet...",
      question: "Frage",
      next: "Weiter",
      of: "Von",
      submit: "Einreichen",
      skip: "Überspringen",
      ratingInputPlaceHolder: "Geben Sie Ihren Kommentar ein (Optional)",
      reinforceButton: "Vertiefen Sie Ihr Lernen",
      yourAnswer: "Ihre Antwort",
      correctAnswer: "Richtige Antwort",
      answerResultEndingPage: "Sie haben {{@}} von {{@@}} Fragen richtig beantwortet.",
      youCan: "Sie können",
      shareTrivvy: "Teilen Sie Trivvy",
      orReturnTo: "oder zurückkehren zu",
      myTrivvys: "Meine Trivvys",
      rewardText: "Nehmen Sie diesen Trivvy, um aufregende Belohnungen zu gewinnen:",
      clickToSeeText: "Klicken Sie hier, um den Text zu sehen",
      notTimed: "Nicht zeitgesteuert",
      viewSummary: "Zusammenfassung anzeigen",
      submitAnonymously: "Anonym einreichen",
      percentToPass: "Prozentsatz zum Bestehen",
      trivvyEnded: "Es tut uns leid. Dieser Trivvy ist abgelaufen am",
      mcqsAreTimed: "Multiple-Choice-Fragen sind zeitlich begrenzt",
      employeeIdRequired: "Mitarbeiter-ID erforderlich",
      employeeId: "Mitarbeiter-ID",
      required: "Erforderlich",
      enterEmployeeId: "Bitte geben Sie die Mitarbeiter-ID ein",
      emailIsRequired: "E-Mail ist erforderlich",
      email: "E-Mail",
      enterEmail: "Bitte geben Sie die E-Mail ein",
      name: "Name",
      nameIsRequired: "Bitte geben Sie den Namen ein",
      endDate: "Enddatum",
      customData: "Benutzerdefinierte Daten",
      correct: "Richtig",
      timedOut: "Zeitüberschreitung",
      submitRatingLoading: "Bewertung wird gesendet, bitte warten",
      submitRatingRequiredMessage: "Sie müssen eine Bewertung abgeben, um die Ergebnisse zu sehen",
      sourceLink: "Quellenlink",
      sourceText: "Quellentext",
      customText: "Benutzerdefinierter Text",
      endingPassingPerMessage1: "Herzlichen Glückwunsch, Sie haben bestanden! Die Bestehensquote beträgt",
      endingPassingPerMessage2: "und Sie haben eine",
      niceJob: "Gute Arbeit",
      endingNoPassMessage1: "Die Bestehensquote beträgt",
      endingNoPassMessage2: "Sie haben eine",
      endingNoPassMessage3: "Sie können es erneut versuchen, um Ihre Punktzahl zu verbessern",
      clickHere: "Klicken Sie hier",
      toRetake: " um es erneut zu versuchen",
      trivvyNotSharedApiMessage: "Sie dürfen dieses Trivvy nicht machen, es ist nicht mit Ihnen geteilt. Bitte kontaktieren Sie Ihren Administrator.",
      passedTrivvyAlreadyApiMessage: "Sie haben das Trivvy bereits bestanden",
      attemptLimitExceededApiMessage: "Entschuldigung, Sie haben das Versuchslimit für das Trivvy überschritten",
      trivvyNotPublishedApiMessage: "Das Trivvy ist nicht veröffentlicht, bitte kontaktieren Sie Ihren Administrator.",
      trivvyAlreadyAttemptedApiMessage: "Sie haben dieses Trivvy bereits versucht und dürfen es nicht erneut machen. Bitte kontaktieren Sie Ihren Administrator.",
      cantTakeTrivvyAgainApiMessage: "Sie können dasselbe Trivvy nicht mehr als einmal machen",
      scaleMinLabel: "Niedrigste",
      scaleMaxLabel: "Höchste",
    },
    "zh": {
      userContentWarning: "请勿在您的回复中分享任何受控/机密信息或不当语言。",
      generatedOn: "生成于",
      questions: "问题",
      takes: "需要",
      seconds: "秒",
      letsDoIt: "让我们开始吧",
      thanksForYourTime: "感谢您的时间！",
      messageSubmittedSuccess: "提交成功。您可以继续添加其他内容。",
      sending: "发送中...",
      question: "问题",
      next: "下一步",
      of: "的",
      submit: "提交",
      skip: "跳过",
      ratingInputPlaceHolder: "输入您的评论（可选）",
      reinforceButton: "强化你的学习",
      yourAnswer: "你的答案",
      correctAnswer: "正确答案",
      answerResultEndingPage: "您正确回答了 {{@}} 个问题中的 {{@@}} 个。",
      youCan: "你可以",
      shareTrivvy: "分享 Trivvy",
      orReturnTo: "或返回到",
      myTrivvys: "我的 Trivvys",
      rewardText: "参加此 trivvy 以赢取丰厚奖品：",
      clickToSeeText: "点击这里查看文字",
      notTimed: "无时间限制",
      viewSummary: "查看摘要",
      submitAnonymously: "匿名提交",
      percentToPass: "通过百分比",
      trivvyEnded: "抱歉。此 trivvy 已于",
      mcqsAreTimed: "多项选择题有时间限制",
    employeeIdRequired: "需要员工ID",
    employeeId: "员工ID",
    required: "必需的",
    enterEmployeeId: "请输入员工ID",
    emailIsRequired: "需要电子邮件",
    email: "电子邮件",
    enterEmail: "请输入电子邮件",
    name: "姓名",
    nameIsRequired: "请输入姓名",
    endDate: "结束日期",
    customData: "自定义数据",
    correct: "正确",
    timedOut: "超时",
    submitRatingLoading: "提交评分，请稍候",
    submitRatingRequiredMessage: "您需要提交评分才能查看结果",
    sourceLink: "源链接",
    sourceText: "源文本",
    customText: "自定义文本",
    endingPassingPerMessage1: "恭喜你通过了！ 通过率是",
    endingPassingPerMessage2: "你达到了",
    niceJob: "干得好",
    endingNoPassMessage1: "通过率是",
    endingNoPassMessage2: "你收到了",
    endingNoPassMessage3: "您可以重考以尝试提高分数",
    clickHere: "点击这里",
    toRetake: " 重新参加考试",
    trivvyNotSharedApiMessage: "您无权参加此Trivvy，它未与您共享，请联系您的管理员。",
    passedTrivvyAlreadyApiMessage: "您已经通过了这个Trivvy",
    attemptLimitExceededApiMessage: "抱歉，您已超出Trivvy的尝试限制",
    trivvyNotPublishedApiMessage: "Trivvy未发布，请联系您的管理员。",
    trivvyAlreadyAttemptedApiMessage: "您已经尝试过这个Trivvy，不允许再次参加，请联系您的管理员。",
    cantTakeTrivvyAgainApiMessage: "同一个Trivvy不能参加两次",
      scaleMinLabel: "最低",
      scaleMaxLabel: "最高",
    },
    "zh-TW": {
      userContentWarning: "請勿在您的回覆中分享任何受控/機密資訊或不當語言。",
      generatedOn: "生成於",
      questions: "問題",
      takes: "需要",
      seconds: "秒",
      letsDoIt: "讓我們開始吧",
      thanksForYourTime: "感謝您的時間！",
      messageSubmittedSuccess: "提交成功。歡迎再新增一則。",
      sending: "傳送中...",
      question: "問題",
      next: "下一步",
      of: "的",
      submit: "提交",
      skip: "跳過",
      ratingInputPlaceHolder: "輸入您的評論（可選）",
      reinforceButton: "強化你的學習",
      yourAnswer: "你的答案",
      correctAnswer: "正確答案",
      answerResultEndingPage: "您正確回答了 {{@}} 個問題中的 {{@@}} 個。",
      youCan: "你可以",
      shareTrivvy: "分享 Trivvy",
      orReturnTo: "或返回到",
      myTrivvys: "我的 Trivvys",
      rewardText: "參加此 trivvy 以贏取豐厚獎品：",
      clickToSeeText: "點擊這裡查看文字",
      notTimed: "無時間限制",
      viewSummary: "查看摘要",
      submitAnonymously: "匿名提交",
      percentToPass: "通過百分比",
      trivvyEnded: "抱歉。此 trivvy 已於",
      mcqsAreTimed: "多項選擇題有時間限制",
      employeeIdRequired: "需要員工ID",
      employeeId: "員工ID",
      required: "必需的",
      enterEmployeeId: "請輸入員工ID",
      emailIsRequired: "需要電子郵件",
      email: "電子郵件",
      enterEmail: "請輸入電子郵件",
      name: "姓名",
      nameIsRequired: "請輸入姓名",
      endDate: "結束日期",
      customData: "自定義數據",
      correct: "正確",
      timedOut: "超時",
      submitRatingLoading: "提交評分，請稍候",
      submitRatingRequiredMessage: "您需要提交評分才能查看結果",
      sourceLink: "源鏈接",
      sourceText: "源文本",
      customText: "自定義文本",
      endingPassingPerMessage1: "恭喜你通過了！ 通過率是",
      endingPassingPerMessage2: "你達到了",
      niceJob: "幹得好",
      endingNoPassMessage1: "通過率是",
      endingNoPassMessage2: "你收到了",
      endingNoPassMessage3: "您可以重考以嘗試提高分數",
      clickHere: "點擊這裡",
      toRetake: " 重新參加考試",
      trivvyNotSharedApiMessage: "您無權參加此Trivvy，它未與您共享，請聯系您的管理員。",
      passedTrivvyAlreadyApiMessage: "您已經通過了這個Trivvy",
      attemptLimitExceededApiMessage: "抱歉，您已超出Trivvy的嘗試限制",
      trivvyNotPublishedApiMessage: "Trivvy未發布，請聯系您的管理員。",
      trivvyAlreadyAttemptedApiMessage: "您已經嘗試過這個Trivvy，不允許再次參加，請聯系您的管理員。",
      cantTakeTrivvyAgainApiMessage: "同一個Trivvy不能參加兩次",
      scaleMinLabel: "最低",
      scaleMaxLabel: "最高",
    },
    "ja": {
      userContentWarning: "回答に、管理された情報・機密情報や不適切な表現を含めないようにしてください。",
      generatedOn: "生成日",
      questions: "質問",
      takes: "かかる",
      seconds: "秒",
      letsDoIt: "やってみよう",
      thanksForYourTime: "お時間をいただきありがとうございました！",
      messageSubmittedSuccess: "送信されました。別のメッセージを追加してください。",
      sending: "送信中...",
      question: "質問",
      next: "次",
      of: "の",
      submit: "提出する",
      skip: "スキップ",
      ratingInputPlaceHolder: "コメントを入力（オプション）",
      reinforceButton: "学習を強化する",
      yourAnswer: "あなたの答え",
      correctAnswer: "正しい答え",
      answerResultEndingPage: "{{@}} 問中 {{@@}} 問正解しました。",
      youCan: "あなたはできます",
      shareTrivvy: "Trivvy を共有する",
      orReturnTo: "または戻る",
      myTrivvys: "私の Trivvys",
      rewardText: "この trivvy を受けてエキサイティングな報酬を獲得してください：",
      clickToSeeText: "テキストを見るにはここをクリック",
      notTimed: "時間制限なし",
      viewSummary: "要約を表示",
      submitAnonymously: "匿名で送信",
      percentToPass: "合格率",
      trivvyEnded: "申し訳ありません。この trivvy は終了しました",
      mcqsAreTimed: "多肢選択問題には時間制限があります",
    employeeIdRequired: "従業員IDが必要です",
    employeeId: "従業員ID",
    required: "必須",
    enterEmployeeId: "従業員IDを入力してください",
    emailIsRequired: "メールアドレスが必要です",
    email: "メール",
    enterEmail: "メールアドレスを入力してください",
    name: "名前",
    nameIsRequired: "名前を入力してください",
    endDate: "終了日",
    customData: "カスタムデータ",
    correct: "正解",
    timedOut: "時間切れ",
    submitRatingLoading: "評価を送信中、しばらくお待ちください",
    submitRatingRequiredMessage: "結果を見るには評価を送信する必要があります",
    sourceLink: "ソースリンク",
    sourceText: "ソーステキスト",
    customText: "カスタムテキスト",
    endingPassingPerMessage1: "おめでとうございます、合格です！ 合格率は",
    endingPassingPerMessage2: "あなたは達成しました",
    niceJob: "よくやった",
    endingNoPassMessage1: "合格率は",
    endingNoPassMessage2: "あなたは受け取りました",
    endingNoPassMessage3: "スコアを向上させるために再受験できます",
    clickHere: "ここをクリック",
    toRetake: " 再受験するために",
    trivvyNotSharedApiMessage: "このTrivvyを受ける権限がありません。管理者に連絡してください。",
    passedTrivvyAlreadyApiMessage: "このTrivvyはすでに合格しています",
    attemptLimitExceededApiMessage: "申し訳ありませんが、Trivvyの試行回数を超えました",
    trivvyNotPublishedApiMessage: "Trivvyは公開されていません。管理者に連絡してください。",
    trivvyAlreadyAttemptedApiMessage: "このTrivvyはすでに試行されており、再受験は許可されていません。管理者に連絡してください。",
    cantTakeTrivvyAgainApiMessage: "同じTrivvyを複数回受験することはできません",
      scaleMinLabel: "最低",
      scaleMaxLabel: "最高",
    },
    "ko": {
      userContentWarning: "답변에 통제된/기밀 정보나 부적절한 언어를 포함하지 마세요.",
      generatedOn: "생성일",
      questions: "질문",
      takes: "걸리다",
      seconds: "초",
      letsDoIt: "시작하자",
      thanksForYourTime: "시간을 내주셔서 감사합니다!",
      messageSubmittedSuccess: "성공적으로 제출되었습니다. 다른 메시지를 추가하셔도 됩니다.",
      sending: "전송 중...",
      question: "질문",
      next: "다음",
      of: "의",
      submit: "제출",
      skip: "건너뛰다",
      ratingInputPlaceHolder: "댓글 입력 (선택 사항)",
      reinforceButton: "학습 강화",
      yourAnswer: "당신의 대답",
      correctAnswer: "정답",
      answerResultEndingPage: "{{@}}개의 질문 중 {{@@}}개를 맞췄습니다.",
      youCan: "당신은 할 수 있습니다",
      shareTrivvy: "Trivvy 공유",
      orReturnTo: "또는 돌아가기",
      myTrivvys: "내 Trivvys",
      rewardText: "이 trivvy를 수행하여 흥미로운 보상을 받으십시오:",
      clickToSeeText: "텍스트를 보려면 여기를 클릭하세요",
      notTimed: "시간 제한 없음",
      viewSummary: "요약 보기",
      submitAnonymously: "익명으로 제출",
      percentToPass: "통과 비율",
      trivvyEnded: "죄송합니다. 이 trivvy는 종료되었습니다",
      mcqsAreTimed: "다중 선택 질문에는 시간 제한이 있습니다",
      employeeIdRequired: "직원 ID가 필요합니다",
      employeeId: "직원 ID",
      required: "필수",
      enterEmployeeId: "직원 ID를 입력하십시오",
      emailIsRequired: "이메일이 필요합니다",
      email: "이메일",
      enterEmail: "이메일을 입력하십시오",
      name: "이름",
      nameIsRequired: "이름을 입력하십시오",
      endDate: "종료 날짜",
      customData: "맞춤 데이터",
      correct: "정답",
      timedOut: "시간 초과",
      submitRatingLoading: "평가를 제출하는 중입니다. 잠시 기다려 주십시오",
      submitRatingRequiredMessage: "결과를 보려면 평가를 제출해야 합니다",
      sourceLink: "소스 링크",
      sourceText: "소스 텍스트",
      customText: "맞춤 텍스트",
      endingPassingPerMessage1: "축하합니다, 합격하셨습니다! 합격률은",
      endingPassingPerMessage2: "당신은 달성했습니다",
      niceJob: "잘 했어요",
      endingNoPassMessage1: "합격률은",
      endingNoPassMessage2: "당신은 받았습니다",
      endingNoPassMessage3: "점수를 향상시키기 위해 다시 시도할 수 있습니다",
      clickHere: "여기를 클릭하십시오",
      toRetake: " 다시 시도하려면",
      trivvyNotSharedApiMessage: "이 Trivvy를 받을 권한이 없습니다. 관리자에게 문의하십시오.",
      passedTrivvyAlreadyApiMessage: "이미 이 Trivvy에 합격했습니다",
      attemptLimitExceededApiMessage: "죄송합니다, Trivvy의 시도 횟수를 초과했습니다",
      trivvyNotPublishedApiMessage: "Trivvy가 공개되지 않았습니다. 관리자에게 문의하십시오.",
      trivvyAlreadyAttemptedApiMessage: "이미 이 Trivvy를 시도했으며, 다시 시도할 수 없습니다. 관리자에게 문의하십시오.",
      cantTakeTrivvyAgainApiMessage: "같은 Trivvy를 두 번 이상 받을 수 없습니다",
  
      scaleMinLabel: "최저",
      scaleMaxLabel: "최고",
    },
    "pt": {
      userContentWarning: "Não compartilhe nenhuma informação controlada / confidencial ou linguagem inadequada em sua resposta.",
      generatedOn: "Gerado em",
      questions: "Perguntas",
      takes: "Leva",
      seconds: "segundos",
      letsDoIt: "Vamos fazer isso",
      thanksForYourTime: "Obrigado pelo seu tempo!",
      messageSubmittedSuccess: "Enviado com sucesso. Fique à vontade para adicionar outro.",
      sending: "Enviando...",
      question: "Pergunta",
      next: "Próximo",
      of: "De",
      submit: "Enviar",
      skip: "Pular",
      ratingInputPlaceHolder: "Digite seu comentário (Opcional)",
      reinforceButton: "Reforce seu aprendizado",
      yourAnswer: "Sua Resposta",
      correctAnswer: "Resposta Correta",
      answerResultEndingPage: "você respondeu corretamente {{@}} de {{@@}} perguntas.",
      youCan: "Você pode",
      shareTrivvy: "Compartilhar Trivvy",
      orReturnTo: "ou voltar para",
      myTrivvys: "Meus Trivvys",
      rewardText: "Faça este trivvy para ganhar prêmios emocionantes:",
      clickToSeeText: "Clique aqui para ver o texto",
      notTimed: "Não cronometrado",
      viewSummary: "Ver resumo",
      submitAnonymously: "Enviar anonimamente",
      percentToPass: "Porcentagem para passar",
      trivvyEnded: "Desculpe. Este trivvy terminou a partir de",
      attemptLimitExceeded: "Desculpe, você excedeu o limite de tentativas do trivvy.",
      trivvyPassed: "Você já passou no trivvy",
      trivvyNotShared: "Você não tem permissão para fazer este trivvy que não foi compartilhado com você",
      alreadyAttempted: "Você já tentou este Trivvy e não tem permissão para fazê-lo novamente",
      cantTakeMoreThanOnce: "Você não pode fazer o mesmo Trivvy mais de uma vez",
      scaleMinLabel: "Mais baixo",
      scaleMaxLabel: "Mais alto",
    },
    "pt-PT": {
      userContentWarning: "Não partilhe qualquer informação controlada / confidencial ou linguagem inadequada na sua resposta.",
      generatedOn: "Gerado em",
      questions: "Perguntas",
      takes: "Leva",
      seconds: "segundos",
      letsDoIt: "Vamos fazer isso",
      thanksForYourTime: "Obrigado pelo seu tempo!",
      messageSubmittedSuccess: "Enviado com sucesso. Sinta-se à vontade para adicionar outro.",
      sending: "A enviar...",
      question: "Pergunta",
      next: "Próximo",
      of: "De",
      submit: "Enviar",
      skip: "Pular",
      ratingInputPlaceHolder: "Digite seu comentário (Opcional)",
      reinforceButton: "Reforce seu aprendizado",
      yourAnswer: "Sua Resposta",
      correctAnswer: "Resposta Correta",
      answerResultEndingPage: "você respondeu corretamente {{@}} de {{@@}} perguntas.",
      youCan: "Você pode",
      shareTrivvy: "Compartilhar Trivvy",
      orReturnTo: "ou voltar para",
      myTrivvys: "Meus Trivvys",
      rewardText: "Faça este trivvy para ganhar prêmios emocionantes:",
      clickToSeeText: "Clique aqui para ver o texto",
      notTimed: "Não cronometrado",
      viewSummary: "Ver resumo",
      submitAnonymously: "Enviar anonimamente",
      percentToPass: "Porcentagem para passar",
      trivvyEnded: "Desculpe. Este trivvy terminou a partir de",
      attemptLimitExceeded: "Desculpe, você excedeu o limite de tentativas do trivvy.",
      trivvyPassed: "Você já passou no trivvy",
      trivvyNotShared: "Você não tem permissão para fazer este trivvy que não foi compartilhado com você",
      alreadyAttempted: "Você já tentou este Trivvy e não tem permissão para fazê-lo novamente",
      cantTakeMoreThanOnce: "Você não pode fazer o mesmo Trivvy mais de uma vez",
      scaleMinLabel: "Mais baixo",
      scaleMaxLabel: "Mais alto",
    },
    "it": {
      userContentWarning: "Non condividere informazioni riservate / controllate o linguaggio inappropriato nella tua risposta.",
      generatedOn: "Generato il",
      questions: "Domande",
      takes: "Richiede",
      seconds: "secondi",
      letsDoIt: "Facciamolo",
      thanksForYourTime: "Grazie per il tuo tempo!",
      messageSubmittedSuccess: "Inviato con successo. Sentiti libero di aggiungerne un altro.",
      sending: "Invio in corso...",
      question: "Domanda",
      next: "Avanti",
      of: "Di",
      submit: "Invia",
      skip: "Salta",
      ratingInputPlaceHolder: "Digita il tuo commento (Facoltativo)",
      reinforceButton: "Rafforza il tuo apprendimento",
      yourAnswer: "La tua Risposta",
      correctAnswer: "Risposta Corretta",
      answerResultEndingPage: "hai risposto correttamente a {{@}} su {{@@}} domande.",
      youCan: "Puoi",
      shareTrivvy: "Condividi Trivvy",
      orReturnTo: "o torna a",
      myTrivvys: "I miei Trivvys",
      rewardText: "Fai questo trivvy per vincere premi entusiasmanti:",
      clickToSeeText: "Clicca qui per vedere il testo",
      notTimed: "Non cronometrato",
      viewSummary: "Visualizza riepilogo",
      submitAnonymously: "Invia anonimamente",
      percentToPass: "Percentuale per passare",
      trivvyEnded: "Spiacente. Questo trivvy è terminato a partire da",
      mcqsAreTimed: "Le domande a scelta multipla sono a tempo",
    employeeIdRequired: "ID dipendente richiesto",
    employeeId: "ID dipendente",
    required: "Richiesto",
    enterEmployeeId: "Per favore inserisci l'ID dipendente",
    emailIsRequired: "Email richiesta",
    email: "Email",
    enterEmail: "Per favore inserisci l'email",
    name: "Nome",
    nameIsRequired: "Per favore inserisci il nome",
    endDate: "Data di fine",
    customData: "Dati personalizzati",
    correct: "Corretto",
    timedOut: "Tempo scaduto",
    submitRatingLoading: "Invio della valutazione in corso, attendere prego",
    submitRatingRequiredMessage: "Devi inviare una valutazione per vedere i risultati",
    sourceLink: "Link sorgente",
    sourceText: "Testo sorgente",
    customText: "Testo personalizzato",
    endingPassingPerMessage1: "Congratulazioni, hai passato! La percentuale di passaggio è",
    endingPassingPerMessage2: "e hai raggiunto un",
    niceJob: "Ottimo lavoro",
    endingNoPassMessage1: "La percentuale di passaggio è",
    endingNoPassMessage2: "Hai ricevuto un",
    endingNoPassMessage3: "Puoi riprovare per cercare di migliorare il tuo punteggio",
    clickHere: "Clicca qui",
    toRetake: " per riprovare",
    trivvyNotSharedApiMessage: "Non sei autorizzato a prendere questo trivvy, non è condiviso con te, contatta il tuo amministratore.",
    passedTrivvyAlreadyApiMessage: "Hai già passato il trivvy",
    attemptLimitExceededApiMessage: "Spiacenti, hai superato il limite di tentativi per il trivvy",
    trivvyNotPublishedApiMessage: "Il trivvy non è pubblicato, contatta il tuo amministratore.",
    trivvyAlreadyAttemptedApiMessage: "Hai già tentato questo Trivvy e non sei autorizzato a riprenderlo. Contatta il tuo amministratore.",
    cantTakeTrivvyAgainApiMessage: "Non puoi prendere lo stesso Trivvy più di una volta",

      scaleMinLabel: "Più basso",
      scaleMaxLabel: "Più alto",
    },
    "ru": {
      userContentWarning: "Пожалуйста, не делитесь конфиденциальной / контролируемой информацией или неуместными выражениями в своём ответе.",
      generatedOn: "Создано",
      questions: "Вопросы",
      takes: "Занимает",
      seconds: "секунды",
      letsDoIt: "Давайте сделаем это",
      thanksForYourTime: "Спасибо за ваше время!",
      messageSubmittedSuccess: "Успешно отправлено. Вы можете добавить ещё одно.",
      sending: "Отправка...",
      question: "Вопрос",
      next: "Далее",
      of: "Из",
      submit: "Отправить",
      skip: "Пропустить",
      ratingInputPlaceHolder: "Введите ваш комментарий (Опционально)",
      reinforceButton: "Укрепите свои знания",
      yourAnswer: "Ваш Ответ",
      correctAnswer: "Правильный Ответ",
      answerResultEndingPage: "вы ответили правильно на {{@}} из {{@@}} вопросов.",
      youCan: "Вы можете",
      shareTrivvy: "Поделиться Trivvy",
      orReturnTo: "или вернуться к",
      myTrivvys: "Мои Trivvys",
      rewardText: "Пройдите этот trivvy, чтобы выиграть захватывающие призы:",
      clickToSeeText: "Нажмите здесь, чтобы увидеть текст",
      notTimed: "Без ограничений по времени",
      viewSummary: "Посмотреть сводку",
      submitAnonymously: "Отправить анонимно",
      percentToPass: "Процент для прохождения",
      trivvyEnded: "Извините. Этот trivvy закончился с",
      "mcqsAreTimed": "Вопросы с несколькими вариантами ответов ограничены по времени",
    "employeeIdRequired": "Требуется идентификатор сотрудника",
    "employeeId": "Идентификатор сотрудника",
    "required": "Обязательно",
    "enterEmployeeId": "Пожалуйста, введите идентификатор сотрудника",
    "emailIsRequired": "Требуется адрес электронной почты",
    "email": "Электронная почта",
    "enterEmail": "Пожалуйста, введите адрес электронной почты",
    "name": "Имя",
    "nameIsRequired": "Пожалуйста, введите имя",
    "endDate": "Дата окончания",
    "customData": "Пользовательские данные",
    "correct": "Правильно",
    "timedOut": "Время вышло",
    "submitRatingLoading": "Отправка оценки, пожалуйста, подождите",
    "submitRatingRequiredMessage": "Вы должны отправить оценку, чтобы увидеть результаты",
    "sourceLink": "Источник",
    "sourceText": "Текст источника",
    "customText": "Пользовательский текст",
    "endingPassingPerMessage1": "Поздравляем, вы прошли! Процент прохождения составляет",
    "endingPassingPerMessage2": "и вы достигли",
    "niceJob": "Отличная работа",
    "endingNoPassMessage1": "Процент прохождения составляет",
    "endingNoPassMessage2": "Вы получили",
    "endingNoPassMessage3": "Вы можете повторить попытку, чтобы улучшить свой результат",
    "clickHere": "Нажмите здесь",
    "toRetake": " чтобы повторить",
    "trivvyNotSharedApiMessage": "У вас нет доступа к этому Trivvy, пожалуйста, свяжитесь с администратором.",
    "passedTrivvyAlreadyApiMessage": "Вы уже прошли этот Trivvy",
    "attemptLimitExceededApiMessage": "Извините, вы превысили лимит попыток для этого Trivvy",
    "trivvyNotPublishedApiMessage": "Этот Trivvy не опубликован, свяжитесь с администратором.",
    "trivvyAlreadyAttemptedApiMessage": "Вы уже пытались пройти этот Trivvy и не можете повторить попытку. Свяжитесь с администратором.",
    "cantTakeTrivvyAgainApiMessage": "Вы не можете пройти один и тот же Trivvy более одного раза",
      scaleMinLabel: "Самый низкий",
      scaleMaxLabel: "Самый высокий",
    },
    "nl": {
      userContentWarning: "Deel in uw antwoord geen gecontroleerde / vertrouwelijke informatie of ongepast taalgebruik.",
      generatedOn: "Gegenereerd op",
      questions: "Vragen",
      takes: "Duur",
      seconds: "seconden",
      letsDoIt: "Laten we het doen",
      thanksForYourTime: "Bedankt voor je tijd!",
      messageSubmittedSuccess: "Succesvol ingediend. Voel je vrij om er nog een toe te voegen.",
      sending: "Verzenden...",
      question: "Vraag",
      next: "Volgende",
      of: "Van",
      submit: "Indienen",
      skip: "Overslaan",
      ratingInputPlaceHolder: "Typ je opmerking (Optioneel)",
      reinforceButton: "Versterk je kennis",
      yourAnswer: "Jouw Antwoord",
      correctAnswer: "Juiste Antwoord",
      answerResultEndingPage: "je hebt {{@}} van de {{@@}} vragen goed beantwoord.",
      youCan: "Je kunt",
      shareTrivvy: "Deel Trivvy",
      orReturnTo: "of terugkeren naar",
      myTrivvys: "Mijn Trivvys",
      rewardText: "Neem deze trivvy om spannende beloningen te winnen:",
      clickToSeeText: "Klik hier om de tekst te zien",
      notTimed: "Niet getimed",
      viewSummary: "Samenvatting bekijken",
      submitAnonymously: "Anoniem indienen",
      percentToPass: "Percentage om te slagen",
      trivvyEnded: "Sorry. Deze trivvy is afgelopen vanaf",
      "mcqsAreTimed": "Meerkeuzevragen zijn getimed",
    "employeeIdRequired": "Werknemers-ID vereist",
    "employeeId": "Werknemers-ID",
    "required": "Vereist",
    "enterEmployeeId": "Voer alstublieft de werknemers-ID in",
    "emailIsRequired": "E-mail is vereist",
    "email": "E-mail",
    "enterEmail": "Voer alstublieft e-mail in",
    "name": "Naam",
    "nameIsRequired": "Voer alstublieft de naam in",
    "endDate": "Einddatum",
    "customData": "Aangepaste gegevens",
    "correct": "Correct",
    "timedOut": "Tijd verstreken",
    "submitRatingLoading": "Beoordeling indienen, even geduld alstublieft",
    "submitRatingRequiredMessage": "U moet een beoordeling indienen om de resultaten te zien",
    "sourceLink": "Bronlink",
    "sourceText": "Brontekst",
    "customText": "Aangepaste tekst",
    "endingPassingPerMessage1": "Gefeliciteerd, je bent geslaagd! Het slagingspercentage is",
    "endingPassingPerMessage2": "en je hebt bereikt",
    "niceJob": "Goed gedaan",
    "endingNoPassMessage1": "Het slagingspercentage is",
    "endingNoPassMessage2": "Je hebt gekregen",
    "endingNoPassMessage3": "Je kunt het opnieuw proberen om je score te verbeteren",
    "clickHere": "Klik hier",
    "toRetake": " om opnieuw te proberen",
    "trivvyNotSharedApiMessage": "Je hebt geen toegang tot deze Trivvy, neem contact op met je beheerder.",
    "passedTrivvyAlreadyApiMessage": "Je hebt deze Trivvy al gehaald",
    "attemptLimitExceededApiMessage": "Sorry, je hebt het pogingslimiet van deze Trivvy overschreden",
    "trivvyNotPublishedApiMessage": "Deze Trivvy is niet gepubliceerd, neem contact op met je beheerder.",
    "trivvyAlreadyAttemptedApiMessage": "Je hebt deze Trivvy al geprobeerd en mag het niet opnieuw proberen. Neem contact op met je beheerder.",
    "cantTakeTrivvyAgainApiMessage": "Je kunt dezelfde Trivvy niet meer dan één keer doen",
      scaleMinLabel: "Laagste",
      scaleMaxLabel: "Hoogste",
    },
    "ar": {
      userContentWarning: "يرجى عدم مشاركة أي معلومات خاضعة للرقابة / سرية أو لغة غير لائقة في ردك.",
      generatedOn: "تم الإنشاء في",
      questions: "أسئلة",
      takes: "يستغرق",
      seconds: "ثواني",
      letsDoIt: "لنقم بذلك",
      thanksForYourTime: "شكراً لوقتك!",
      messageSubmittedSuccess: "تم الإرسال بنجاح. يمكنك إضافة رسالة أخرى.",
      sending: "جاري الإرسال...",
      question: "سؤال",
      next: "التالي",
      of: "من",
      submit: "إرسال",
      skip: "تخطي",
      ratingInputPlaceHolder: "اكتب تعليقك (اختياري)",
      reinforceButton: "عزز تعلمك",
      yourAnswer: "إجابتك",
      correctAnswer: "الإجابة الصحيحة",
      answerResultEndingPage: "أجبت بشكل صحيح على {{@}} من {{@@}} أسئلة.",
      youCan: "يمكنك",
      shareTrivvy: "شارك Trivvy",
      orReturnTo: "أو العودة إلى",
      myTrivvys: "Trivvys الخاص بي",
      rewardText: "خذ هذه الاختبار لكسب مكافآت مثيرة:",
      clickToSeeText: "انقر هنا لرؤية النص",
      notTimed: "غير محدود بوقت",
      viewSummary: "عرض الملخص",
      submitAnonymously: "إرسال بشكل مجهول",
      percentToPass: "النسبة المئوية للنجاح",
      trivvyEnded: "عذراً. انتهى هذا الاختبار اعتبارًا من",
      "mcqsAreTimed": "الأسئلة متعددة الخيارات محددة بالوقت",
      "employeeIdRequired": "مطلوب هوية الموظف",
      "employeeId": "هوية الموظف",
      "required": "مطلوب",
      "enterEmployeeId": "يرجى إدخال هوية الموظف",
      "emailIsRequired": "البريد الإلكتروني مطلوب",
      "email": "البريد الإلكتروني",
      "enterEmail": "يرجى إدخال البريد الإلكتروني",
      "name": "الاسم",
      "nameIsRequired": "يرجى إدخال الاسم",
      "endDate": "تاريخ الانتهاء",
      "customData": "البيانات المخصصة",
      "correct": "صحيح",
      "timedOut": "انتهى الوقت",
      "submitRatingLoading": "جاري تقديم التقييم، يرجى الانتظار",
      "submitRatingRequiredMessage": "يجب تقديم التقييم لرؤية النتائج",
      "sourceLink": "رابط المصدر",
      "sourceText": "نص المصدر",
      "customText": "النص المخصص",
      "endingPassingPerMessage1": "تهانينا، لقد نجحت! نسبة النجاح هي",
      "endingPassingPerMessage2": "وقد حققت",
      "niceJob": "عمل جيد",
      "endingNoPassMessage1": "نسبة النجاح هي",
      "endingNoPassMessage2": "لقد حصلت على",
      "endingNoPassMessage3": "يمكنك إعادة المحاولة لتحسين نتيجتك",
      "clickHere": "انقر هنا",
      "toRetake": " لإعادة المحاولة",
      "trivvyNotSharedApiMessage": "غير مسموح لك بأخذ هذه التريففي لم يتم مشاركتها معك، يرجى الاتصال بالمسؤول.",
      "passedTrivvyAlreadyApiMessage": "لقد اجتزت هذه التريففي بالفعل",
      "attemptLimitExceededApiMessage": "عذراً، لقد تجاوزت حد المحاولات لهذه التريففي",
      "trivvyNotPublishedApiMessage": "لم يتم نشر هذه التريففي، يرجى الاتصال بالمسؤول.",
      "trivvyAlreadyAttemptedApiMessage": "لقد حاولت هذه التريففي بالفعل ولا يمكنك إعادة المحاولة. يرجى الاتصال بالمسؤول.",
      "cantTakeTrivvyAgainApiMessage": "لا يمكنك أخذ نفس التريففي أكثر من مرة",
      scaleMinLabel: "الأدنى",
      scaleMaxLabel: "الأعلى",
    },
    "hi": {
      userContentWarning: "कृपया अपने उत्तर में कोई भी नियंत्रित/गोपनीय जानकारी या अनुचित भाषा साझा न करें।",
      generatedOn: "पर उत्पन्न",
      questions: "प्रश्न",
      takes: "लेता है",
      seconds: "सेकंड",
      letsDoIt: "चलो करते हैं",
      thanksForYourTime: "आपका समय देने के लिए धन्यवाद!",
      messageSubmittedSuccess: "सफलतापूर्वक जमा किया गया। बेझिझक एक और जोड़ें।",
      sending: "भेज रहे हैं...",
      question: "प्रश्न",
      next: "अगला",
      of: "का",
      submit: "प्रस्तुत",
      skip: "छोड़ें",
      ratingInputPlaceHolder: "अपनी टिप्पणी टाइप करें (वैकल्पिक)",
      reinforceButton: "अपनी शिक्षा को मजबूत करें",
      yourAnswer: "आपका उत्तर",
      correctAnswer: "सही उत्तर",
      answerResultEndingPage: "आपने {{@@}} में से {{@}} प्रश्न सही उत्तर दिए हैं।",
      youCan: "आप कर सकते हैं",
      shareTrivvy: "Trivvy साझा करें",
      orReturnTo: "या लौटें",
      myTrivvys: "मेरे Trivvys",
      rewardText: "रोमांचक पुरस्कार जीतने के लिए इस trivvy को लें:",
    clickToSeeText: "पाठ देखने के लिए यहां क्लिक करें",
    notTimed: "समयबद्ध नहीं",
    viewSummary: "सारांश देखें",
    submitAnonymously: "गुमनाम रूप से सबमिट करें",
    percentToPass: "पास करने के लिए प्रतिशत",
    trivvyEnded: "क्षमा करें। यह trivvy समाप्त हो गया है",
    "mcqsAreTimed": "बहुविकल्पीय प्रश्न समयबद्ध होते हैं",
    "employeeIdRequired": "कर्मचारी आईडी आवश्यक है",
    "employeeId": "कर्मचारी आईडी",
    "required": "आवश्यक",
    "enterEmployeeId": "कृपया कर्मचारी आईडी दर्ज करें",
    "emailIsRequired": "ईमेल आवश्यक है",
    "email": "ईमेल",
    "enterEmail": "कृपया ईमेल दर्ज करें",
    "name": "नाम",
    "nameIsRequired": "कृपया नाम दर्ज करें",
    "endDate": "अंतिम तिथि",
    "customData": "कस्टम डेटा",
    "correct": "सही",
    "timedOut": "समय समाप्त",
    "submitRatingLoading": "रेटिंग जमा कर रहा है, कृपया प्रतीक्षा करें",
    "submitRatingRequiredMessage": "परिणाम देखने के लिए आपको रेटिंग जमा करनी होगी",
    "sourceLink": "स्रोत लिंक",
    "sourceText": "स्रोत पाठ",
    "customText": "कस्टम टेक्स्ट",
    "endingPassingPerMessage1": "बधाई हो, आपने पास किया! पासिंग प्रतिशत है",
    "endingPassingPerMessage2": "और आपने प्राप्त किया है",
    "niceJob": "अच्छा काम",
    "endingNoPassMessage1": "पासिंग प्रतिशत है",
    "endingNoPassMessage2": "आपको प्राप्त हुआ है",
    "endingNoPassMessage3": "अपने स्कोर को सुधारने के लिए आप पुनः प्रयास कर सकते हैं",
    "clickHere": "यहां क्लिक करें",
    "toRetake": " पुनः प्रयास करने के लिए",
    "trivvyNotSharedApiMessage": "आपको यह trivvy लेने की अनुमति नहीं है, कृपया अपने व्यवस्थापक से संपर्क करें।",
    "passedTrivvyAlreadyApiMessage": "आपने पहले ही इस trivvy को पास कर लिया है",
    "attemptLimitExceededApiMessage": "क्षमा करें, आपने इस trivvy के प्रयास की सीमा को पार कर लिया है",
    "trivvyNotPublishedApiMessage": "यह trivvy प्रकाशित नहीं हुआ है, कृपया अपने व्यवस्थापक से संपर्क करें।",
    "trivvyAlreadyAttemptedApiMessage": "आपने पहले ही इस trivvy का प्रयास किया है और आपको इसे पुनः लेने की अनुमति नहीं है। कृपया अपने व्यवस्थापक से संपर्क करें।",
    "cantTakeTrivvyAgainApiMessage": "आप एक ही trivvy को एक से अधिक बार नहीं ले सकते",
      scaleMinLabel: "सबसे कम",
      scaleMaxLabel: "सबसे अधिक",
    },
    "bn": {
      userContentWarning: "অনুগ্রহ করে আপনার উত্তরে কোনো নিয়ন্ত্রিত/গোপনীয় তথ্য বা অনুপযুক্ত ভাষা শেয়ার করবেন না।",
      generatedOn: "জেনারেট করা হয়েছে",
      questions: "প্রশ্ন",
      takes: "নেয়",
      seconds: "সেকেন্ড",
      letsDoIt: "আসুন এটি করি",
      thanksForYourTime: "আপনার সময়ের জন্য ধন্যবাদ!",
      messageSubmittedSuccess: "সফলভাবে জমা দেওয়া হয়েছে। আরও একটি যোগ করতে স্বাধীন।",
      sending: "পাঠানো হচ্ছে...",
      question: "প্রশ্ন",
      next: "পরবর্তী",
      of: "এর",
      submit: "জমা দিন",
      skip: "এড়িয়ে যান",
      ratingInputPlaceHolder: "আপনার মন্তব্য টাইপ করুন (ঐচ্ছিক)",
      reinforceButton: "আপনার শিক্ষাকে শক্তিশালী করুন",
      yourAnswer: "আপনার উত্তর",
      correctAnswer: "সঠিক উত্তর",
      answerResultEndingPage: "আপনি {{@@}} এর মধ্যে {{@}} প্রশ্ন সঠিকভাবে উত্তর দিয়েছেন।",
      youCan: "আপনি পারেন",
      shareTrivvy: "Trivvy শেয়ার করুন",
      orReturnTo: "বা ফিরে যান",
      myTrivvys: "আমার Trivvys",
      rewardText: "রোমাঞ্চকর পুরস্কার জিততে এই trivvy নিন:",
      clickToSeeText: "পাঠ দেখতে এখানে ক্লিক করুন",
      notTimed: "সময় নির্ধারণ করা নেই",
      viewSummary: "সারসংক্ষেপ দেখুন",
      submitAnonymously: "বেনামি জমা দিন",
      percentToPass: "পাস করার জন্য শতাংশ",
      trivvyEnded: "দুঃখিত। এই trivvy শেষ হয়ে গেছে",
      "mcqsAreTimed": "একাধিক পছন্দের প্রশ্নগুলি সময়সীমা নির্ধারিত",
    "employeeIdRequired": "কর্মচারীর আইডি প্রয়োজন",
    "employeeId": "কর্মচারীর আইডি",
    "required": "প্রয়োজন",
    "enterEmployeeId": "অনুগ্রহ করে কর্মচারীর আইডি প্রবেশ করান",
    "emailIsRequired": "ইমেইল প্রয়োজন",
    "email": "ইমেইল",
    "enterEmail": "অনুগ্রহ করে ইমেইল প্রবেশ করান",
    "name": "নাম",
    "nameIsRequired": "অনুগ্রহ করে নাম প্রবেশ করান",
    "endDate": "সমাপ্তির তারিখ",
    "customData": "কাস্টম তথ্য",
    "correct": "সঠিক",
    "timedOut": "সময় শেষ",
    "submitRatingLoading": "রেটিং জমা হচ্ছে, অনুগ্রহ করে অপেক্ষা করুন",
    "submitRatingRequiredMessage": "ফলাফল দেখতে হলে আপনাকে রেটিং জমা করতে হবে",
    "sourceLink": "উৎসের লিঙ্ক",
    "sourceText": "উৎসের পাঠ্য",
    "customText": "কাস্টম পাঠ্য",
    "endingPassingPerMessage1": "অভিনন্দন, আপনি উত্তীর্ণ হয়েছেন! পাসিং শতাংশ হল",
    "endingPassingPerMessage2": "এবং আপনি অর্জন করেছেন",
    "niceJob": "ভাল কাজ",
    "endingNoPassMessage1": "পাসিং শতাংশ হল",
    "endingNoPassMessage2": "আপনি পেয়েছেন",
    "endingNoPassMessage3": "আপনার স্কোর উন্নতির জন্য আপনি আবার চেষ্টা করতে পারেন",
    "clickHere": "এখানে ক্লিক করুন",
    "toRetake": " আবার চেষ্টা করতে",
    "trivvyNotSharedApiMessage": "আপনাকে এই Trivvy গ্রহণের অনুমতি নেই, এটি আপনার সাথে ভাগ করা হয়নি, অনুগ্রহ করে আপনার প্রশাসকের সাথে যোগাযোগ করুন।",
    "passedTrivvyAlreadyApiMessage": "আপনি ইতিমধ্যে এই Trivvy পাস করেছেন",
    "attemptLimitExceededApiMessage": "দুঃখিত, আপনি Trivvy-এর প্রচেষ্টার সীমা অতিক্রম করেছেন",
    "trivvyNotPublishedApiMessage": "Trivvy প্রকাশিত হয়নি, অনুগ্রহ করে আপনার প্রশাসকের সাথে যোগাযোগ করুন।",
    "trivvyAlreadyAttemptedApiMessage": "আপনি ইতিমধ্যে এই Trivvy চেষ্টা করেছেন এবং আপনাকে এটি আবার চেষ্টা করার অনুমতি নেই। অনুগ্রহ করে আপনার প্রশাসকের সাথে যোগাযোগ করুন।",
    "cantTakeTrivvyAgainApiMessage": "আপনি একই Trivvy একাধিকবার গ্রহণ করতে পারবেন না",
      scaleMinLabel: "সর্বনিম্ন",
      scaleMaxLabel: "সর্বোচ্চ",
    },
    "pa": {
      userContentWarning: "ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੇ ਜਵਾਬ ਵਿੱਚ ਕੋਈ ਵੀ ਨਿਯੰਤਰਿਤ/ਗੁਪਤ ਜਾਣਕਾਰੀ ਜਾਂ ਅਣਉਚਿਤ ਭਾਸ਼ਾ ਸਾਂਝੀ ਨਾ ਕਰੋ।",
      generatedOn: "ਤਿਆਰ ਕੀਤਾ ਗਿਆ",
      questions: "ਸਵਾਲ",
      takes: "ਲੱਗਦਾ ਹੈ",
      seconds: "ਸਕਿੰਟ",
      letsDoIt: "ਆਓ ਇਸ ਨੂੰ ਕਰੋ",
      thanksForYourTime: "ਤੁਹਾਡਾ ਸਮਾਂ ਦੇਣ ਲਈ ਧੰਨਵਾਦ!",
      messageSubmittedSuccess: "ਸਫਲਤਾ ਨਾਲ ਜਮ੍ਹਾ ਕੀਤਾ ਗਿਆ। ਇੱਕ ਹੋਰ ਜੋੜਨ ਲਈ ਬੇਝਿਜਕ ਮਹਿਸੂਸ ਕਰੋ।",
      sending: "ਭੇਜ ਰਿਹਾ ਹੈ...",
      question: "ਸਵਾਲ",
      next: "ਅਗਲਾ",
      of: "ਦਾ",
      submit: "ਜਮ੍ਹਾਂ ਕਰੋ",
      skip: "ਛੱਡੋ",
      ratingInputPlaceHolder: "ਆਪਣੀ ਟਿੱਪਣੀ ਲਿਖੋ (ਚੋਣਵਿਕਲਪ)",
      reinforceButton: "ਆਪਣੇ ਸਿੱਖਣ ਨੂੰ ਮਜ਼ਬੂਤ ਬਣਾਓ",
      yourAnswer: "ਤੁਹਾਡਾ ਜਵਾਬ",
      correctAnswer: "ਸਹੀ ਜਵਾਬ",
      answerResultEndingPage: "ਤੁਸੀਂ {{@@}} ਵਿੱਚੋਂ {{@}} ਸਵਾਲ ਸਹੀ ਜਵਾਬ ਦਿੱਤੇ ਹਨ।",
      youCan: "ਤੁਸੀਂ ਕਰ ਸਕਦੇ ਹੋ",
      shareTrivvy: "Trivvy ਸ਼ੇਅਰ ਕਰੋ",
      orReturnTo: "ਜਾਂ ਵਾਪਸ ਜਾਓ",
      myTrivvys: "ਮੇਰੇ Trivvys",
      rewardText: "ਇਹ trivvy ਪੂਰਾ ਕਰਨ ਲਈ ਰੋਮਾਂਚਕ ਇਨਾਮ ਜਿੱਤਣ ਲਈ ਲਓ:",
    clickToSeeText: "ਪਾਠ ਵੇਖਣ ਲਈ ਇੱਥੇ ਕਲਿੱਕ ਕਰੋ",
    notTimed: "ਸਮਾਂ ਸੀਮਤ ਨਹੀਂ",
    viewSummary: "ਸੰਖੇਪ ਵੇਖੋ",
    submitAnonymously: "ਅਨਾਮੀ ਤੌਰ 'ਤੇ ਪੇਸ਼ ਕਰੋ",
    percentToPass: "ਪਾਸ ਹੋਣ ਲਈ ਪ੍ਰਤੀਸ਼ਤ",
    trivvyEnded: "ਮਾਫ ਕਰਨਾ। ਇਹ trivvy ਇਸ ਮਿਤੀ ਨੂੰ ਖਤਮ ਹੋ ਗਈ ਹੈ",
    "mcqsAreTimed": "ਮਲਟੀਪਲ ਚੋਇਸ ਪ੍ਰਸ਼ਨ ਸਮੇਂ ਦੇ ਨਾਲ ਹੁੰਦੇ ਹਨ",
    "employeeIdRequired": "ਕਰਮਚਾਰੀ ਆਈਡੀ ਲੋੜੀਂਦਾ ਹੈ",
    "employeeId": "ਕਰਮਚਾਰੀ ਆਈਡੀ",
    "required": "ਲੋੜੀਂਦਾ",
    "enterEmployeeId": "ਕਿਰਪਾ ਕਰਕੇ ਕਰਮਚਾਰੀ ਆਈਡੀ ਦਾਖਲ ਕਰੋ",
    "emailIsRequired": "ਈਮੇਲ ਲੋੜੀਂਦਾ ਹੈ",
    "email": "ਈਮੇਲ",
    "enterEmail": "ਕਿਰਪਾ ਕਰਕੇ ਈਮੇਲ ਦਾਖਲ ਕਰੋ",
    "name": "ਨਾਮ",
    "nameIsRequired": "ਕਿਰਪਾ ਕਰਕੇ ਨਾਮ ਦਾਖਲ ਕਰੋ",
    "endDate": "ਅੰਤਮ ਮਿਤੀ",
    "customData": "ਕਸਟਮ ਡੇਟਾ",
    "correct": "ਸਹੀ",
    "timedOut": "ਸਮਾਂ ਖਤਮ ਹੋਇਆ",
    "submitRatingLoading": "ਰੇਟਿੰਗ ਸਬਮਿਟ ਕਰ ਰਹੇ ਹੋ, ਕਿਰਪਾ ਕਰਕੇ ਉਡੀਕ ਕਰੋ",
    "submitRatingRequiredMessage": "ਨਤੀਜੇ ਵੇਖਣ ਲਈ ਤੁਹਾਨੂੰ ਰੇਟਿੰਗ ਸਬਮਿਟ ਕਰਨੀ ਪਵੇਗੀ",
    "sourceLink": "ਸਰੋਤ ਲਿੰਕ",
    "sourceText": "ਸਰੋਤ ਪਾਠ",
    "customText": "ਕਸਟਮ ਪਾਠ",
    "endingPassingPerMessage1": "ਮੁਬਾਰਕਾਂ, ਤੁਸੀਂ ਪਾਸ ਕਰ ਲਿਆ! ਪਾਸਿੰਗ ਪ੍ਰਤੀਸ਼ਤ ਹੈ",
    "endingPassingPerMessage2": "ਅਤੇ ਤੁਸੀਂ ਪ੍ਰਾਪਤ ਕੀਤਾ ਹੈ",
    "niceJob": "ਵਧੀਆ ਕੰਮ",
    "endingNoPassMessage1": "ਪਾਸਿੰਗ ਪ੍ਰਤੀਸ਼ਤ ਹੈ",
    "endingNoPassMessage2": "ਤੁਸੀਂ ਪ੍ਰਾਪਤ ਕੀਤਾ ਹੈ",
    "endingNoPassMessage3": "ਤੁਸੀਂ ਆਪਣਾ ਸਕੋਰ ਸਧਾਰਨ ਲਈ ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰ ਸਕਦੇ ਹੋ",
    "clickHere": "ਇੱਥੇ ਕਲਿੱਕ ਕਰੋ",
    "toRetake": " ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰਨ ਲਈ",
    "trivvyNotSharedApiMessage": "ਤੁਹਾਨੂੰ ਇਹ Trivvy ਲੈਣ ਦੀ ਆਗਿਆ ਨਹੀਂ ਹੈ, ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੇ ਪ੍ਰਬੰਧਕ ਨਾਲ ਸੰਪਰਕ ਕਰੋ।",
    "passedTrivvyAlreadyApiMessage": "ਤੁਸੀਂ ਪਹਿਲਾਂ ਹੀ ਇਹ Trivvy ਪਾਸ ਕਰ ਲਿਆ ਹੈ",
    "attemptLimitExceededApiMessage": "ਮਾਫ ਕਰਨਾ, ਤੁਸੀਂ ਇਸ Trivvy ਦੀ ਕੋਸ਼ਿਸ਼ ਦੀ ਹੱਦ ਪਾਰ ਕਰ ਲਈ ਹੈ",
    "trivvyNotPublishedApiMessage": "ਇਹ Trivvy ਪ੍ਰਕਾਸ਼ਿਤ ਨਹੀਂ ਹੈ, ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੇ ਪ੍ਰਬੰਧਕ ਨਾਲ ਸੰਪਰਕ ਕਰੋ।",
    "trivvyAlreadyAttemptedApiMessage": "ਤੁਸੀਂ ਪਹਿਲਾਂ ਹੀ ਇਹ Trivvy ਦੀ ਕੋਸ਼ਿਸ਼ ਕਰ ਲਈ ਹੈ ਅਤੇ ਤੁਸੀਂ ਇਸ ਨੂੰ ਮੁੜ ਲੈਣ ਦੀ ਆਗਿਆ ਨਹੀਂ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੇ ਪ੍ਰਬੰਧਕ ਨਾਲ ਸੰਪਰਕ ਕਰੋ।",
    "cantTakeTrivvyAgainApiMessage": "ਤੁਸੀਂ ਇੱਕ ਹੀ Trivvy ਬਾਰ-ਬਾਰ ਨਹੀਂ ਲੈ ਸਕਦੇ",
      scaleMinLabel: "ਸਭ ਤੋਂ ਘੱਟ",
      scaleMaxLabel: "ਸਭ ਤੋਂ ਵੱਧ",
    },
    "tr": {
      userContentWarning: "Lütfen yanıtınızda kontrollü / gizli bilgi veya uygunsuz dil paylaşmayın.",
      generatedOn: "Oluşturuldu",
      questions: "Sorular",
      takes: "Sürer",
      seconds: "saniye",
      letsDoIt: "Hadi yapalım",
      thanksForYourTime: "Zamanınız için teşekkürler!",
      messageSubmittedSuccess: "Başarıyla gönderildi. Başka bir tane eklemekten çekinmeyin.",
      sending: "Gönderiliyor...",
      question: "Soru",
      next: "Sonraki",
      of: "nin",
      submit: "Gönder",
      skip: "Geç",
      ratingInputPlaceHolder: "Yorumunuzu yazın (İsteğe bağlı)",
      reinforceButton: "Öğreniminizi güçlendirin",
      yourAnswer: "Senin Cevabın",
      correctAnswer: "Doğru Cevap",
      answerResultEndingPage: "{{@@}} sorudan {{@}} soruyu doğru cevapladınız.",
      youCan: "Yapabilirsiniz",
      shareTrivvy: "Trivvy'yi Paylaş",
      orReturnTo: "veya geri dön",
      myTrivvys: "Benim Trivvys",
      rewardText: "Heyecan verici ödüller kazanmak için bu trivvy'yi alın:",
      clickToSeeText: "Metni görmek için buraya tıklayın",
      notTimed: "Sınırsız süre",
      viewSummary: "Özeti görüntüle",
      submitAnonymously: "Anonim olarak gönder",
      percentToPass: "Geçmek için yüzde",
      trivvyEnded: "Üzgünüz. Bu trivvy şu tarihte sona erdi",
      "mcqsAreTimed": "Çoktan seçmeli sorular zamanlıdır",
      "employeeIdRequired": "Çalışan Kimlik Numarası gereklidir",
      "employeeId": "Çalışan Kimlik Numarası",
      "required": "Gerekli",
      "enterEmployeeId": "Lütfen çalışan kimlik numarasını girin",
      "emailIsRequired": "E-posta gereklidir",
      "email": "E-posta",
      "enterEmail": "Lütfen e-posta adresinizi girin",
      "name": "Ad",
      "nameIsRequired": "Lütfen adınızı girin",
      "endDate": "Bitiş Tarihi",
      "customData": "Özel Veri",
      "correct": "Doğru",
      "timedOut": "Zaman aşımına uğradı",
      "submitRatingLoading": "Değerlendirme gönderiliyor, lütfen bekleyin",
      "submitRatingRequiredMessage": "Sonuçları görmek için değerlendirme yapmalısınız",
      "sourceLink": "Kaynak bağlantısı",
      "sourceText": "Kaynak metni",
      "customText": "Özel metin",
      "endingPassingPerMessage1": "Tebrikler, geçtiniz! Geçme Yüzdesi",
      "endingPassingPerMessage2": "ve başardınız",
      "niceJob": "Harika iş",
      "endingNoPassMessage1": "Geçme yüzdesi",
      "endingNoPassMessage2": "aldınız",
      "endingNoPassMessage3": "Skorunuzu iyileştirmek için tekrar deneyebilirsiniz",
      "clickHere": "Buraya tıklayın",
      "toRetake": " tekrar yapmak için",
      "trivvyNotSharedApiMessage": "Bu trivvy sizinle paylaşılmamış, lütfen yöneticinizle iletişime geçin.",
      "passedTrivvyAlreadyApiMessage": "Bu trivvy'i zaten geçtiniz",
      "attemptLimitExceededApiMessage": "Üzgünüz, trivvy deneme limitini aştınız",
      "trivvyNotPublishedApiMessage": "Trivvy yayınlanmamış, lütfen yöneticinizle iletişime geçin.",
      "trivvyAlreadyAttemptedApiMessage": "Bu Trivvy'i zaten denediniz ve tekrar almanıza izin verilmiyor. Lütfen yöneticinizle iletişime geçin.",
      "cantTakeTrivvyAgainApiMessage": "Aynı Trivvy'yi bir daha alamazsınız",
      scaleMinLabel: "En Düşük",
      scaleMaxLabel: "En Yüksek",
    },
    "vi": {
      userContentWarning: "Vui lòng không chia sẻ bất kỳ thông tin kiểm soát/bảo mật hoặc ngôn ngữ không phù hợp nào trong câu trả lời của bạn.",
      generatedOn: "Được tạo vào",
      questions: "Câu hỏi",
      takes: "Mất",
      seconds: "giây",
      letsDoIt: "Hãy làm điều đó",
      thanksForYourTime: "Cảm ơn bạn đã dành thời gian!",
      messageSubmittedSuccess: "Gửi thành công. Bạn có thể thêm một cái khác.",
      sending: "Đang gửi...",
      question: "Câu hỏi",
      next: "Tiếp theo",
      of: "của",
      submit: "Gửi",
      skip: "Bỏ qua",
      ratingInputPlaceHolder: "Nhập nhận xét của bạn (Tùy chọn)",
      reinforceButton: "Củng cố kiến thức của bạn",
      yourAnswer: "Câu Trả Lời Của Bạn",
      correctAnswer: "Câu Trả Lời Đúng",
      answerResultEndingPage: "bạn đã trả lời đúng {{@}} trên {{@@}} câu hỏi.",
      youCan: "Bạn có thể",
      shareTrivvy: "Chia sẻ Trivvy",
      orReturnTo: "hoặc trở lại",
      myTrivvys: "Trivvys của tôi",
      rewardText: "Thực hiện trivvy này để giành những phần thưởng hấp dẫn:",
      clickToSeeText: "Nhấn vào đây để xem văn bản",
      notTimed: "Không giới hạn thời gian",
      viewSummary: "Xem tổng kết",
      submitAnonymously: "Gửi ẩn danh",
      percentToPass: "Phần trăm để vượt qua",
      trivvyEnded: "Xin lỗi. Trivvy này đã kết thúc từ",
      "mcqsAreTimed": "Câu hỏi lựa chọn nhiều có giới hạn thời gian",
    "employeeIdRequired": "Cần có ID nhân viên",
    "employeeId": "ID nhân viên",
    "required": "Bắt buộc",
    "enterEmployeeId": "Vui lòng nhập ID nhân viên",
    "emailIsRequired": "Email là bắt buộc",
    "email": "Email",
    "enterEmail": "Vui lòng nhập email",
    "name": "Tên",
    "nameIsRequired": "Vui lòng nhập tên",
    "endDate": "Ngày kết thúc",
    "customData": "Dữ liệu tùy chỉnh",
    "correct": "Đúng",
    "timedOut": "Hết thời gian",
    "submitRatingLoading": "Đang gửi đánh giá, vui lòng đợi",
    "submitRatingRequiredMessage": "Bạn cần gửi đánh giá để xem kết quả",
    "sourceLink": "Liên kết nguồn",
    "sourceText": "Văn bản nguồn",
    "customText": "Văn bản tùy chỉnh",
    "endingPassingPerMessage1": "Chúc mừng bạn đã vượt qua! Tỷ lệ qua",
    "endingPassingPerMessage2": "và bạn đã đạt được",
    "niceJob": "Làm việc tốt",
    "endingNoPassMessage1": "Tỷ lệ qua là",
    "endingNoPassMessage2": "Bạn đã nhận được",
    "endingNoPassMessage3": "Bạn có thể làm lại để cải thiện điểm số của mình",
    "clickHere": "Nhấp vào đây",
    "toRetake": " để làm lại",
    "trivvyNotSharedApiMessage": "Bạn không được phép tham gia trivvy này vì nó không được chia sẻ với bạn, vui lòng liên hệ với người quản trị của bạn.",
    "passedTrivvyAlreadyApiMessage": "Bạn đã vượt qua trivvy này rồi",
    "attemptLimitExceededApiMessage": "Xin lỗi, bạn đã vượt quá giới hạn số lần thử trivvy",
    "trivvyNotPublishedApiMessage": "Trivvy này chưa được xuất bản, vui lòng liên hệ với người quản trị của bạn.",
    "trivvyAlreadyAttemptedApiMessage": "Bạn đã thử trivvy này và không được phép thử lại. Vui lòng liên hệ với người quản trị của bạn.",
    "cantTakeTrivvyAgainApiMessage": "Bạn không thể tham gia lại cùng một trivvy",
      scaleMinLabel: "Thấp nhất",
      scaleMaxLabel: "Cao nhất",
    },
    "fa": {
      userContentWarning: "لطفاً هیچ‌گونه اطلاعات محرمانه/کنترل‌شده یا زبان نامناسب را در پاسخ خود به اشتراک نگذارید.",
      "generatedOn": "تولید شده در",
      "questions": "سوالات",
      "takes": "زمان می‌برد",
      "seconds": "ثانیه",
      "letsDoIt": "بیایید انجام دهیم",
      "thanksForYourTime": "از وقت شما متشکریم!",
      "messageSubmittedSuccess": "با موفقیت ارسال شد. می‌توانید یکی دیگر اضافه کنید.",
      "sending": "در حال ارسال...",
      "question": "سوال",
      "next": "بعدی",
      "of": "از",
      "submit": "ثبت",
      "skip": "رد کردن",
      "ratingInputPlaceHolder": "نظر خود را وارد کنید (اختیاری)",
      "reinforceButton": "تقویت یادگیری شما",
      "yourAnswer": "پاسخ شما",
      "correctAnswer": "پاسخ صحیح",
      "answerResultEndingPage": "شما {{@}} سوال از {{@@}} سوال را به درستی پاسخ داده‌اید.",
      "youCan": "شما می‌توانید",
      "shareTrivvy": "اشتراک گذاری Trivvy",
      "orReturnTo": "یا بازگشت به",
      "myTrivvys": "Trivvy‌های من",
      "rewardText": "برای کسب جوایز هیجان انگیز، این Trivvy را بگیرید:",
      "clickToSeeText": "برای مشاهده متن اینجا کلیک کنید",
      "notTimed": "بدون محدودیت زمانی",
      "viewSummary": "مشاهده خلاصه",
      "submitAnonymously": "ارسال به صورت ناشناس",
      "percentToPass": "درصد پاس",
      "trivvyEnded": "متأسفیم. این Trivvy به پایان رسیده است در تاریخ",
  
      "mcqsAreTimed": "سوالات چند گزینه‌ای محدود به زمان هستند",
      "employeeIdRequired": "شناسه کارمند الزامی است",
      "employeeId": "شناسه کارمند",
      "required": "الزامی است",
      "enterEmployeeId": "لطفاً شناسه کارمند را وارد کنید",
      "emailIsRequired": "ایمیل الزامی است",
      "email": "ایمیل",
      "enterEmail": "لطفاً ایمیل خود را وارد کنید",
      "name": "نام",
      "nameIsRequired": "لطفاً نام خود را وارد کنید",
      "endDate": "تاریخ پایان",
      "customData": "داده‌های سفارشی",
      "correct": "صحیح",
      "timedOut": "زمان به پایان رسیده است",
      "submitRatingLoading": "در حال ارسال امتیاز، لطفاً منتظر بمانید",
      "submitRatingRequiredMessage": "برای مشاهده نتایج باید امتیاز خود را ثبت کنید",
      "sourceLink": "لینک منبع",
      "sourceText": "متن منبع",
      "customText": "متن سفارشی",
      "endingPassingPerMessage1": "تبریک! درصد قبولی",
      "endingPassingPerMessage2": "و شما به",
      "niceJob": "کار خوبی انجام دادید",
      "endingNoPassMessage1": "درصد قبولی",
      "endingNoPassMessage2": "شما دریافت کردید",
      "endingNoPassMessage3": "شما می‌توانید دوباره امتحان کنید تا نمره‌ی خود را بهبود بخشید",
      "clickHere": "اینجا کلیک کنید",
      "toRetake": " برای دوباره گرفتن",
      "trivvyNotSharedApiMessage": "شما مجاز به شرکت در این Trivvy نیستید چون با شما به اشتراک گذاشته نشده است، لطفاً با مدیر خود تماس بگیرید.",
      "passedTrivvyAlreadyApiMessage": "شما این Trivvy را قبلاً گذرانده‌اید",
      "attemptLimitExceededApiMessage": "متاسفیم، شما به حد تلاش Trivvy رسیده‌اید",
      "trivvyNotPublishedApiMessage": "این Trivvy منتشر نشده است، لطفاً با مدیر خود تماس بگیرید.",
      "trivvyAlreadyAttemptedApiMessage": "شما این Trivvy را قبلاً امتحان کرده‌اید و اجازه‌ی امتحان مجدد ندارید. لطفاً با مدیر خود تماس بگیرید.",
      "cantTakeTrivvyAgainApiMessage": "شما نمی‌توانید همان Trivvy را بیش از یک بار بگیرید",
      scaleMinLabel: "کمترین",
      scaleMaxLabel: "بیشترین",
    },
    "pl": {
      userContentWarning: "Prosimy nie udostępniać żadnych informacji poufnych / kontrolowanych ani niestosownego języka w odpowiedzi.",
        rewardText: "Weź udział w tym trivvy, aby wygrać ekscytujące nagrody:",
        clickToSeeText: "Kliknij tutaj, aby zobaczyć tekst",
        notTimed: "Bez limitu czasu",
        viewSummary: "Zobacz podsumowanie",
        submitAnonymously: "Wyślij anonimowo",
        percentToPass: "Procent do zaliczenia",
        trivvyEnded: "Przepraszamy. Ten trivvy zakończył się",
       
        generatedOn: "Wygenerowano dnia",
        questions: "Pytania",
        takes: "Czas trwania",
        seconds: "sekund",
        letsDoIt: "Zróbmy to",
        thanksForYourTime: "Dziękujemy za Twój czas!",
        messageSubmittedSuccess: "Pomyślnie przesłano. Możesz dodać kolejną wiadomość.",
        sending: "Wysyłanie...",
        question: "Pytanie",
        next: "Następne",
        of: "z",
        submit: "Wyślij",
        skip: "Pomiń",
        ratingInputPlaceHolder: "Wpisz swój komentarz (opcjonalnie)",
        reinforceButton: "Wzmocnij swoje uczenie się",
        yourAnswer: "Twoja odpowiedź",
        correctAnswer: "Poprawna odpowiedź",
        answerResultEndingPage: "udzieliłeś odpowiedzi na {{@}} z {{@@}} pytań poprawnie.",
        youCan: "Możesz",
        shareTrivvy: "Udostępnij Trivvy",
        orReturnTo: "lub wróć do",
        myTrivvys: "Moje Trivvys",
        mcqsAreTimed: "Pytania wielokrotnego wyboru są ograniczone czasowo",
    employeeIdRequired: "Wymagany identyfikator pracownika",
    employeeId: "Identyfikator pracownika",
    required: "Wymagane",
    enterEmployeeId: "Proszę wprowadzić identyfikator pracownika",
    emailIsRequired: "Wymagany adres email",
    email: "Email",
    enterEmail: "Proszę wprowadzić adres email",
    name: "Imię",
    nameIsRequired: "Proszę wprowadzić imię",
    endDate: "Data zakończenia",
    customData: "Dane niestandardowe",
    correct: "Poprawne",
    timedOut: "Przekroczono czas",
    submitRatingLoading: "Przesyłanie oceny, proszę czekać",
    submitRatingRequiredMessage: "Musisz przesłać ocenę, aby zobaczyć wyniki",
    sourceLink: "Link źródłowy",
    sourceText: "Tekst źródłowy",
    customText: "Tekst niestandardowy",
    endingPassingPerMessage1: "Gratulacje, zdałeś! Procent zdawalności wynosi",
    endingPassingPerMessage2: "i osiągnąłeś",
    niceJob: "Dobra robota",
    endingNoPassMessage1: "Procent zdawalności wynosi",
    endingNoPassMessage2: "Otrzymałeś",
    endingNoPassMessage3: "Możesz powtórzyć, aby spróbować poprawić swój wynik",
    clickHere: "Kliknij tutaj",
    toRetake: " aby powtórzyć",
    trivvyNotSharedApiMessage: "Nie masz uprawnień do tego Trivvy, nie jest ono z tobą udostępnione. Skontaktuj się ze swoim administratorem.",
    passedTrivvyAlreadyApiMessage: "Już zdałeś to Trivvy",
    attemptLimitExceededApiMessage: "Przepraszamy, przekroczyłeś limit prób dla Trivvy",
    trivvyNotPublishedApiMessage: "Trivvy nie jest opublikowane, skontaktuj się ze swoim administratorem.",
    trivvyAlreadyAttemptedApiMessage: "Już próbowałeś tego Trivvy i nie możesz go ponownie przystąpić. Skontaktuj się ze swoim administratorem.",
    cantTakeTrivvyAgainApiMessage: "Nie możesz przystąpić do tego samego Trivvy więcej niż raz",
      scaleMinLabel: "Najniższy",
      scaleMaxLabel: "Najwyższy",
      },
      "uk": {
        userContentWarning: "Будь ласка, не діліться конфіденційною/контрольованою інформацією чи недоречними висловлюваннями у своїй відповіді.",
        rewardText: "Беріть участь у цьому trivvy, щоб виграти захоплюючі нагороди:",
        clickToSeeText: "Натисніть тут, щоб побачити текст",
        notTimed: "Без обмеження часу",
        viewSummary: "Переглянути підсумок",
        submitAnonymously: "Надіслати анонімно",
        percentToPass: "Відсоток для проходження",
        trivvyEnded: "Вибачте. Цей trivvy закінчився",
       
        generatedOn: "Згенеровано",
        questions: "Питання",
        takes: "Триває",
        seconds: "секунд",
        letsDoIt: "Зробимо це",
        thanksForYourTime: "Дякуємо за ваш час!",
        messageSubmittedSuccess: "Успішно надіслано. Ви можете додати ще одне.",
        sending: "Надсилання...",
        question: "Питання",
        next: "Далі",
        of: "з",
        submit: "Надіслати",
        skip: "Пропустити",
        ratingInputPlaceHolder: "Введіть ваш коментар (необов'язково)",
        reinforceButton: "Зміцніть своє навчання",
        yourAnswer: "Ваша відповідь",
        correctAnswer: "Правильна відповідь",
        answerResultEndingPage: "ви відповіли на {{@}} з {{@@}} питань правильно.",
        youCan: "Ви можете",
        shareTrivvy: "Поділіться Trivvy",
        orReturnTo: "або повернутися до",
        myTrivvys: "Мої Trivvys",
         mcqsAreTimed: "Запитання з кількома варіантами відповіді мають обмеження за часом",
    employeeIdRequired: "Потрібен ідентифікатор працівника",
    employeeId: "Ідентифікатор працівника",
    required: "Необхідно",
    enterEmployeeId: "Введіть ідентифікатор працівника",
    emailIsRequired: "Необхідна електронна адреса",
    email: "Електронна адреса",
    enterEmail: "Введіть електронну адресу",
    name: "Ім'я",
    nameIsRequired: "Введіть ім'я",
    endDate: "Дата закінчення",
    customData: "Спеціальні дані",
    correct: "Правильний",
    timedOut: "Час вичерпано",
    submitRatingLoading: "Надсилання рейтингу, будь ласка, зачекайте",
    submitRatingRequiredMessage: "Ви повинні подати рейтинг, щоб побачити результати",
    sourceLink: "Посилання на джерело",
    sourceText: "Текст джерела",
    customText: "Спеціальний текст",
    endingPassingPerMessage1: "Вітаємо, ви пройшли! Процентна ставка становить",
    endingPassingPerMessage2: "і ви досягли",
    niceJob: "Гарна робота",
    endingNoPassMessage1: "Процентна ставка становить",
    endingNoPassMessage2: "Ви отримали",
    endingNoPassMessage3: "Ви можете спробувати ще раз, щоб покращити свій результат",
    clickHere: "Натисніть тут",
    toRetake: " щоб повторити",
    trivvyNotSharedApiMessage: "Ви не маєте права брати цей Trivvy, він не поділяється з вами, зв'яжіться з адміністратором.",
    passedTrivvyAlreadyApiMessage: "Ви вже пройшли цей Trivvy",
    attemptLimitExceededApiMessage: "Вибачте, ви перевищили ліміт спроб Trivvy",
    trivvyNotPublishedApiMessage: "Trivvy не опубліковано, зв'яжіться з адміністратором.",
    trivvyAlreadyAttemptedApiMessage: "Ви вже спробували цей Trivvy і не маєте права повторювати. Зв'яжіться з адміністратором.",
    cantTakeTrivvyAgainApiMessage: "Ви не можете приймати один і той же Trivvy більше одного разу",
      scaleMinLabel: "Найнижчий",
      scaleMaxLabel: "Найвищий",
      }
  
    
  };

// Requested language -> English -> the key itself. The last step matters
// because a language block can be missing a key the English block has: without
// it those spots rendered as literally nothing.
export const getTextFromLanguageCodeAndKey = (languageCode, textKey) => {
    if (languageCode && languageCode !== "en" && languages[languageCode]) {
        const localisedText = languages[languageCode][textKey];
        if (localisedText) {
            return localisedText;
        }
    }

    const englishText = languages["en"][textKey];
    if (englishText) {
        return englishText;
    }

    return textKey;
}
  